// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pricingCardContainer_gsJhE {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 522px;
  font-family: "Inter", sans-serif;
  margin: 20px auto;
}

.pricingBox_sVW2z {
  width: 265px;
  border: 1px solid #16c09832;
  border-radius: 32px 32px 0px 0px;
  text-align: center;
  padding: 24px;
  padding-bottom: 15px;
  border-bottom: none;
  margin-bottom: -1px;
  background-color: var(--_10a37f-background);
  color: var(--white-background);
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.price_jSh1t {
  font-size: clamp(20px, 5vw, 42px);
  font-weight: bold;
  margin: 0;
}

.perMonth_Mnshp {
  font-size: clamp(14px, 4vw, 20px);
  font-weight: 400;
}

.docPrice_L98QJ {
  font-size: clamp(18px, 5vw, 22px);
  font-weight: 400;
  margin: 4px 0;
}

.priceTag_Npe2_ {
  font-weight: 400;
  font-size: clamp(18px, 5vw, 22px);
}

.planDetails_ek9vo {
  padding: 24px 10px 24px 10px;
  width: 80%;
  max-width: 522px;
  background-color: #f7f7f7;
  border-radius: 32px;
  text-align: left;
}

@media (min-width: 768px) {
  .planDetails_ek9vo {
    padding: 20px;
  }
  .pricingBox_sVW2z {
    padding: 10px 32px;
  }
}

.planTitle_ASOU6 {
  font-size: clamp(18px, 6vw, 28px);
  font-weight: 400;
  color: #18181b;
  margin: 0;
  margin-bottom: 8px;
}

.featuresList_AyulY {
  list-style: none;
  padding: 0;
  margin: 0;
  margin-left: 40px;
}

.featureItem_CKKCV {
  font-size: clamp(12px, 3.5vw, 14px);
  display: flex;
  font-weight: 400;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  color: #555454;
  margin-bottom: 9px;
}

.button_uQLHn {
  width: 100%;
  background-color: #22463d;
  color: var(--white-background);
  border: none;
  border-radius: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 54px;
  font-size: clamp(12px, 3.5vw, 14px);
  font-weight: 700;
  cursor: pointer;
  margin-top: 15px;
  text-align: center;
  padding: 12px 20px;
  -webkit-border-radius: 40px;
  -moz-border-radius: 40px;
  -ms-border-radius: 40px;
  -o-border-radius: 40px;
}
sup {
  font-size: 0.7em; 
  vertical-align: super; 
}

.button_uQLHn:hover {
  background-color: #163328;
}

@media (max-width: 576px) {
  .pricingCardContainer_gsJhE {
    margin: 10px auto;
  }

  .planDetails_ek9vo {
    border-radius: 24px;
  }

  .pricingBox_sVW2z {
    border-radius: 24px 24px 0 0;
    width: 50%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/PricingPlanCard/PricingPlanCard.module.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;EAC5B,UAAU;EACV,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,4BAA4B;IAC5B,UAAU;EACZ;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap\");\n\n.pricingCardContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  max-width: 522px;\n  font-family: \"Inter\", sans-serif;\n  margin: 20px auto;\n}\n\n.pricingBox {\n  width: 265px;\n  border: 1px solid #16c09832;\n  border-radius: 32px 32px 0px 0px;\n  text-align: center;\n  padding: 24px;\n  padding-bottom: 15px;\n  border-bottom: none;\n  margin-bottom: -1px;\n  background-color: var(--_10a37f-background);\n  color: var(--white-background);\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.price {\n  font-size: clamp(20px, 5vw, 42px);\n  font-weight: bold;\n  margin: 0;\n}\n\n.perMonth {\n  font-size: clamp(14px, 4vw, 20px);\n  font-weight: 400;\n}\n\n.docPrice {\n  font-size: clamp(18px, 5vw, 22px);\n  font-weight: 400;\n  margin: 4px 0;\n}\n\n.priceTag {\n  font-weight: 400;\n  font-size: clamp(18px, 5vw, 22px);\n}\n\n.planDetails {\n  padding: 24px 10px 24px 10px;\n  width: 80%;\n  max-width: 522px;\n  background-color: #f7f7f7;\n  border-radius: 32px;\n  text-align: left;\n}\n\n@media (min-width: 768px) {\n  .planDetails {\n    padding: 20px;\n  }\n  .pricingBox {\n    padding: 10px 32px;\n  }\n}\n\n.planTitle {\n  font-size: clamp(18px, 6vw, 28px);\n  font-weight: 400;\n  color: #18181b;\n  margin: 0;\n  margin-bottom: 8px;\n}\n\n.featuresList {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  margin-left: 40px;\n}\n\n.featureItem {\n  font-size: clamp(12px, 3.5vw, 14px);\n  display: flex;\n  font-weight: 400;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 10px;\n  color: #555454;\n  margin-bottom: 9px;\n}\n\n.button {\n  width: 100%;\n  background-color: #22463d;\n  color: var(--white-background);\n  border: none;\n  border-radius: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 54px;\n  font-size: clamp(12px, 3.5vw, 14px);\n  font-weight: 700;\n  cursor: pointer;\n  margin-top: 15px;\n  text-align: center;\n  padding: 12px 20px;\n  -webkit-border-radius: 40px;\n  -moz-border-radius: 40px;\n  -ms-border-radius: 40px;\n  -o-border-radius: 40px;\n}\nsup {\n  font-size: 0.7em; \n  vertical-align: super; \n}\n\n.button:hover {\n  background-color: #163328;\n}\n\n@media (max-width: 576px) {\n  .pricingCardContainer {\n    margin: 10px auto;\n  }\n\n  .planDetails {\n    border-radius: 24px;\n  }\n\n  .pricingBox {\n    border-radius: 24px 24px 0 0;\n    width: 50%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pricingCardContainer": `pricingCardContainer_gsJhE`,
	"pricingBox": `pricingBox_sVW2z`,
	"price": `price_jSh1t`,
	"perMonth": `perMonth_Mnshp`,
	"docPrice": `docPrice_L98QJ`,
	"priceTag": `priceTag_Npe2_`,
	"planDetails": `planDetails_ek9vo`,
	"planTitle": `planTitle_ASOU6`,
	"featuresList": `featuresList_AyulY`,
	"featureItem": `featureItem_CKKCV`,
	"button": `button_uQLHn`
};
export default ___CSS_LOADER_EXPORT___;
